import logo from "../../assets/images/plantyn_logo.svg";

import "./ForgottenPassword.less";

import React, { Component } from "react";
import { translate } from "react-i18next";
import StepWizard from "react-step-wizard";

import EnterAddress from "./EnterAddress/EnterAddress";
import EnterPassword from "./EnterPassword/EnterPassword";
import NoScoodleAccount from "./NoScoodleAccount/NoScoodleAccount";
import SuperdogInfo from "../WizardSteps/SuperdogInfo/SuperdogInfo";
import { getParsedQueryString } from "../../utils/query";
import { ForgottenProviderContext } from "../../contexts/contexts";

class ForgottenPassword extends Component {
	state = {
		provider: "",
		setProvider: provider => this.setState({ provider })
	};

	render() {
		const t = this.props.t;

		return (
			<ForgottenProviderContext.Provider value={this.state}>
				<div className="forgotten-password">
					<h1>{t("forgottenPassword")}</h1>
					<StepWizard transitions={{}} initialStep={this.getInitialStep()}>
						<EnterAddress />
						<SuperdogInfo description={t("emailSentDescription")} />
						<NoScoodleAccount />
						<EnterPassword />
					</StepWizard>
					<img className="plantyn_logo" src={logo} alt="" />
				</div>
			</ForgottenProviderContext.Provider>
		);
	}

	getInitialStep = () => {
		return getParsedQueryString().validate ? 4 : 1;
	};
}

export default translate("forgottenPassword")(ForgottenPassword);



// WEBPACK FOOTER //
// ./src/components/ForgottenPassword/ForgottenPassword.js